import { Scissors, Globe, MapPin, Phone, Mail, Store, ShoppingBag, Home as HomeIcon, Star, Heart, Crown, Zap, Coffee, Stethoscope, Facebook, Instagram, AtSign, Music2, MessageCircle } from "lucide-react";
import { ROOT_DOMAIN } from "../utils/businessUrl";

// Páginas de Turnlink (no del negocio). Absolutas al dominio raíz: en mibarber.turnlink.app
// cualquier ruta cae en la agenda del negocio, y Google Wallet exige que privacidad,
// términos y soporte sean alcanzables desde donde se ofrece el pase.
const TURNLINK = `https://${ROOT_DOMAIN}`;
const TURNLINK_LINKS = [
  { href: `${TURNLINK}/privacy`, label: "Privacidad" },
  { href: `${TURNLINK}/terms`, label: "Términos" },
  { href: `${TURNLINK}/#contacto`, label: "Soporte" },
];

const iconMap = { Scissors, Store, ShoppingBag, Home: HomeIcon, Star, Heart, Crown, Zap, Coffee, Stethoscope };
const normalizeUrl = (url) => {
  if (!url) return "";
  if (/^https?:\/\//.test(url)) return url;
  if (url.startsWith("https:")) return `https://${url.slice(6)}`;
  if (url.startsWith("http:")) return `http://${url.slice(5)}`;
  return `https://${url}`;
};
const SOCIAL = [
  { key: "whatsapp", icon: MessageCircle, label: "WhatsApp" }, { key: "instagram", icon: Instagram, label: "Instagram" }, { key: "facebook", icon: Facebook, label: "Facebook" },
  { key: "tiktok", icon: Music2, label: "TikTok" }, { key: "twitter", icon: AtSign, label: "X" }, { key: "website", icon: Globe, label: "Sitio web" },
];

/**
 * Pie de la página pública, centrado y compacto: marca (logo, nombre, slogan), contacto
 * (mapa / teléfono / correo), redes como íconos (WhatsApp incluido) y crédito a Turnlink.
 * Sin horario: la disponibilidad real ya se ve al reservar y el impreso se desactualizaba.
 */
export default function Footer({ clientData }) {
  const p = clientData?.personalization || {};
  const b = clientData?.business || {};
  const Icon = iconMap[p.selectedIcon] || Scissors;
  const phone = Array.isArray(b.phones) ? b.phones[0] : b.phones;
  const wa = clientData?.whatsintegration?.connectedNumber || (phone ? String(phone).replace(/\D/g, "") : "");
  const social = SOCIAL
    .map((s) => ({ ...s, href: s.key === "whatsapp" ? (wa ? `https://wa.me/${wa}` : "") : normalizeUrl(b.links?.[s.key]) }))
    .filter((s) => s.href);
  const hasContact = b.address || phone || b.email;

  return (
    <footer className="cp-foot" translate="no">
      <div className="cp-foot-inner">
        <div className="cp-foot-title">
          <span className="cp-brand-icon">{p.logoType === "image" && p.logoImage ? <img src={p.logoImage} alt="" /> : <Icon size={22} />}</span>
          <span className="cp-foot-name">{b.name || "Turnlink"}</span>
        </div>
        <p className="cp-foot-slogan">{b.slogan || "Agenda tu cita en línea, sin llamadas ni esperas."}</p>

        {hasContact && (
          <ul className="cp-foot-contact">
            {b.address && <li>{b.mapsUrl ? <a href={b.mapsUrl} target="_blank" rel="noopener noreferrer"><MapPin size={16} /> <span>{b.address}</span></a> : <span><MapPin size={16} /> <span>{b.address}</span></span>}</li>}
            {phone && <li><a href={`tel:${phone}`}><Phone size={16} /> <span>{phone}</span></a></li>}
            {b.email && <li><a href={`mailto:${b.email}`}><Mail size={16} /> <span>{b.email}</span></a></li>}
          </ul>
        )}

        {social.length > 0 && (
          <div className="cp-foot-social">
            {social.map(({ key, icon: I, label, href }) => (
              <a key={key} className={`cp-foot-soc ${key === "whatsapp" ? "is-wa" : ""}`} href={href} target="_blank" rel="noopener noreferrer" title={label} aria-label={label}><I size={19} /></a>
            ))}
          </div>
        )}

        <div className="cp-foot-legal">
          <span>© {new Date().getFullYear()} {b.name || "Turnlink"}. Todos los derechos reservados.</span>
          <span>Agenda hecha con <a href={TURNLINK} target="_blank" rel="noopener noreferrer">Turnlink</a> · ¿Quieres una para tu negocio?</span>
          <nav className="cp-foot-links" aria-label="Turnlink">
            {TURNLINK_LINKS.map((l) => <a key={l.label} href={l.href} target="_blank" rel="noopener noreferrer">{l.label}</a>)}
          </nav>
        </div>
      </div>
    </footer>
  );
}
